export default __webpack_public_path__ + "static/media/course-details-bg.7bd02f48.png";